import APIConnector from "../lib/APIConnector";
import FirebaseConnector from "../lib/FirebaseConnector";

import Settings from '../base/Settings'
const apiConnector = new APIConnector({ timeout: 30000 })
const firebaseConnector = new FirebaseConnector({ timeout: 30000 })

export default class RestaurantConfig {
  static get endpoint(){
    return Settings.SERVICE_DOMAIN
  }
  static get endpointDynamicAppLink() {
    return `https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=${Settings.API_KEY}`
  }
  static get endpointRestaurants() {
    return `${RestaurantConfig.endpoint}/restaurant`;
  }
  static get endpointSaveRestaurant() {
    return `${RestaurantConfig.endpointRestaurants}/save`;
  }
  static get endpointDeleteRestaurant() {
    return `${RestaurantConfig.endpointRestaurants}/delete`;
  }
  static get endpointTicketTypes() {
    return `${RestaurantConfig.endpointRestaurants}/ticketTypes`;
  }
  static get endpoinMenuCategories(){
    return `${RestaurantConfig.endpointRestaurants}/menu/categories`;
  }
  static get endpoinSaveMenuCategories(){
    return `${RestaurantConfig.endpoinMenuCategories}/save`;
  }
  static get endpointDeleteMenuCategory() {
    return `${RestaurantConfig.endpoinMenuCategories}/delete`;
  }
  static get endpointUpdateMenu(){
    return `${RestaurantConfig.endpointRestaurants}/menu/update`;
  }
  static get endpointSaveTicketType() {
    return `${RestaurantConfig.endpointTicketTypes}/save`;
  }
  static get endpointDeleteTicketType() {
    return `${RestaurantConfig.endpointTicketTypes}/delete`;
  }
  static get endpointCategories() {
    return `${RestaurantConfig.endpointTicketTypes}/categories`;
  }
  static get endpointOrders() {
    return `${RestaurantConfig.endpointRestaurants}/orders`;
  }
  static get endpointDeliverOrder() {
    return `${RestaurantConfig.endpointRestaurants}/order/deliver`;
  }
  static get endpointReadyToDeliver() {
    return `${RestaurantConfig.endpointRestaurants}/order/readyToDeliver`;
  }
  static get endpointOrderToCook() {
    return `${RestaurantConfig.endpointRestaurants}/order/sendToCook`;
  }
  static get endpointSaveTickets() {
    return `${RestaurantConfig.endpointTickets}/save`;
  }
  static get endpointDeleteTicket() {
    return `${RestaurantConfig.endpointTickets}/delete`;
  }
  static get endpointRegisterOrderListener() {
    return `${RestaurantConfig.endpointRestaurants}/registerListener`;
  }
  static get endpointDeleteOrderListener() {
    return `${RestaurantConfig.endpointRestaurants}/deleteListener`;
  }
  static get endpointStatistics() {
    return `${RestaurantConfig.endpointRestaurants}/statistics`;
  }
  static get endpointReservations() {
    return `${RestaurantConfig.endpointRestaurants}/reservations`;
  }
  static get endpointSaveReservationState() {
    return `${RestaurantConfig.endpointReservations}/saveState`;
  }
  static get endpointDDJJ() {
    return `${RestaurantConfig.endpointRestaurants}/ddjj`;
  }
  static get endpointDDJJByTable() {
    return `${RestaurantConfig.endpointRestaurants}/ddjjByTable`;
  }
  static get endpointControlDDJJ() {
    return `${RestaurantConfig.endpointDDJJ}/control`;
  } 
  static get APIConnector() {
    return apiConnector
  }
  static get FirestoreConnector() {
    return firebaseConnector
  }
}



// WEBPACK FOOTER //
// ./src/provider/restaurant/RestaurantConfig.js